import { Injectable } from '@angular/core';
import { BaseService } from "../base/base.service";
import { SchemasFactory, ContentFactory } from '../../squidex';

@Injectable({ providedIn: 'root' })
export class ArticleTypeService extends BaseService {

    constructor(contentFactory: ContentFactory) {
        super('article-type', contentFactory);
    }
}
